// src/pages/Exercise/ExerciseTypeSelection.tsx
import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import {
  Quiz,
  Edit,
  School,
  AutoStories,
  Calculate,
  Link,
  Sort,
  Functions,
  FormatListNumbered,
} from '@mui/icons-material';

// Map exercise types to Material-UI icons
const getExerciseIcon = (exerciseTypeCode: string) => {
  const iconProps = { sx: { fontSize: 60, color: '#3f51b5' } };
  
  switch (exerciseTypeCode) {
    case 'fill_in_the_blanks':
      return <Edit {...iconProps} />;
    case 'material_based_ai_assisted':
      return <AutoStories {...iconProps} />;
    case 'material_based_multichoice':
    case 'reading_comprehension_multichoice':
    case 'true_false':
      return <Quiz {...iconProps} />;
    case 'pairing':
      return <Link {...iconProps} />;
    case 'sort_to_boxes':
      return <Sort {...iconProps} />;
    case 'math_arit_2operand_1phase':
    case 'math_arit_2operand_2phase':
      return <Calculate {...iconProps} />;
    case 'math_arit_rounding_precision':
      return <Functions {...iconProps} />;
    case 'ordering':
      return <FormatListNumbered {...iconProps} />;
    default:
      return <School {...iconProps} />;
  }
};

interface ExerciseTypeSelectionProps {
  exerciseTypes: {
    exerciseTypeCode: string;
    exerciseTypeName: string;
    pictureFileName: string;
  }[];
  onSelectType: (typeCode: string) => void;
}

const ExerciseTypeSelection: React.FC<ExerciseTypeSelectionProps> = ({ exerciseTypes, onSelectType }) => {
  return (
    <Box mt={3}>
      <Typography variant="h5" gutterBottom>
        Valitse harjoituksen tyyppi
      </Typography>
      <Grid container spacing={3}>
        {exerciseTypes.map((type) => (
          <Grid item xs={12} sm={6} md={4} key={type.exerciseTypeCode}>
            <Card
              sx={{ 
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={() => onSelectType(type.exerciseTypeCode)}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    height: '100px',
                  }}
                >
                  {getExerciseIcon(type.exerciseTypeCode)}
                </Box>
                <Typography variant="h6" textAlign="center">
                  {type.exerciseTypeName}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ExerciseTypeSelection;
